import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from 'src/app/pipe/safehtmlpipe';

@Component({
  selector: 'app-upsell-addons',
  templateUrl: './upsell-addons.component.html',
  styleUrls: ['./upsell-addons.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, SafeHtmlPipe, TranslatePipe],
})
export class UpsellAddonsComponent {
  @Input() upsellList: any[] = [];
  @Input() preferredCurrency: string = 'GBP';
  @Input() currencySymbol: string = '£';
  @Input() selectedLanguage: string = 'en';

  @Output() addonChanged = new EventEmitter<{ event: any; offerData: any }>();

  constructor() { }

  onCheckboxChange(event: any, offerData: any) {
    this.addonChanged.emit({ event, offerData });
  }

  formatPrice(offer: any) {
    if (!offer) return '';
    const priceObj = offer?.price || offer?.value || null;
    if (priceObj && typeof priceObj === 'object') {
      return `${this.currencySymbol}${priceObj[this.preferredCurrency] ?? priceObj['GBP'] ?? ''}`;
    }
    if (typeof priceObj === 'number' || typeof priceObj === 'string') {
      return `${this.currencySymbol}${priceObj}`;
    }
    return '';
  }
}
